<script setup lang="ts">
import { useRouter } from "vue-router";
import type { HandlungBausteinProps, DeeplinkData } from "@/api/handlungen/types.ts";
import { DsButton } from "@demvsystems/design-components";

type LinkFactoryFunction = ( data: DeeplinkData ) => string

const props = defineProps<HandlungBausteinProps<DeeplinkData>>();
const linkFactoryMap: Record<string, LinkFactoryFunction> = {
  checkup: ( _data: DeeplinkData ) => '/check-up'
} as const

function makeRoute () {
  return { path: linkFactoryMap[props.baustein.data.section]( props.baustein.data ) }
}

const router = useRouter()
if (props.baustein.data.redirectAutomatically) {
  router.push( makeRoute() )
}

function onClick ()
{
  router.push( makeRoute())
}

</script>

<template>
  <div>
    <DsButton
      variant="secondary"
      external
      class="my-3 mr-auto"
      @click="onClick"
    >
      {{ baustein.data.label }}
    </DsButton>
  </div>
</template>

<style>

</style>
